import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'jb-modal',
  templateUrl: './modal.component.html',
  styleUrls: [
    './modal.component.scss'
  ]
})
export class ModalComponent {
  public showModal: boolean = false;
  public excludes: Array<string> = ['#jb-modal #modal-content'];
  
  @Input() public clickoutsideExclude: string = '';
  
  constructor() { }
  
  public ngOnInit() {
    this.clickoutsideExclude.split(',').forEach((exclude) => {
      this.excludes.push(exclude);
    });
  }
  
  public openModal() {
    this.showModal = true;
  }
  
  public closeModal() {
    this.showModal = false;
  }
}


// WEBPACK FOOTER //
// ./src/app/global/modal/modal.component.ts